module.exports = __webpack_public_path__ + "static/media/kind.2e448d09.png";